import { injectable } from 'inversify';

import container from '@core/di';

import BaseStore from '@core/stores/base';
import { UserAccount, UserAccountDTO } from '@shared/models/useraccount';
import UserAccountsService from '@shared/services/useraccounts';
import { ListRequestParams } from '@shared/types/services';
import { runInAction } from 'mobx';

@injectable()
export default class UserAccountStore extends BaseStore<UserAccount, UserAccountsService> {
  static diToken = Symbol('useraccounts-store');

  constructor() {
    super({ service: container.get<UserAccountsService>(UserAccountsService.diToken) });

    this.loading = {
      list: true,
      item: false,
    };
  }

  getAllClinicians = async () => {
    return this.service.getAllClinicians();
  };

  getList = async (params: ListRequestParams) => {
    runInAction(() => {
      this.loading.list = true;
    });

    try {
      const { items, pageInfo } = await this.service.getAccountsList(params);

      runInAction(() => {
        this._list = items;
        this._pageInfo = pageInfo;
      });

      return {
        items,
        pageInfo,
      };
    } finally {
      runInAction(() => {
        this.loading.list = false;
      });
    }
  };

  changeRole = async (ssoId: string, data) => {
    return this.service.changeRole(ssoId, data);
  };

  deactivateAccount = async (ssoId: string) => {
    return this.service.deactivateAccount(ssoId);
  };

  activateAccount = async (ssoId: string) => {
    return this.service.activateAccount(ssoId);
  };

  reinviteUser = async (ssoId: string) => {
    return this.service.reinviteUser(ssoId);
  };

  create = async (data: UserAccountDTO) => {
    return this.service.create(data);
  };
}
